tinymce.addI18n("oc", {
    "#": "",
    "Accessibility": "",
    "Accordion": "",
    "Accordion body...": "",
    "Accordion summary...": "",
    "Action": "Accion",
    "Activity": "Activitat",
    "Address": "Adre\xe7as",
    "Advanced": "Avan\xe7at",
    "Align": "Alinhament",
    "Align center": "Alinhar al centre",
    "Align left": "Alinhar a esqu\xe8rra",
    "Align right": "Alinhar a drecha",
    "Alignment": "Alinhament",
    "Alignment {0}": "",
    "All": "Tot",
    "Alternative description": "",
    "Alternative source": "Font alternativa",
    "Alternative source URL": "URL font alternativa",
    "Anchor": "Ancora",
    "Anchor...": "Ancora...",
    "Anchors": "Anc\xf2ras",
    "Animals and Nature": "Animals e Natura",
    "Arrows": "Fl\xe8chas",
    "B": "",
    "Background color": "Color de r\xe8ireplan",
    "Background color {0}": "",
    "Black": "Negre",
    "Block": "Bl\xf2c",
    "Block {0}": "",
    "Blockquote": "Citacion",
    "Blocks": "Bl\xf2ts",
    "Blue": "Blau",
    "Blue component": "",
    "Body": "C\xf2s",
    "Bold": "Gras",
    "Border": "Bordadura",
    "Border color": "Color de la bordadura",
    "Border style": "Estil bordadura",
    "Border width": "Largor bordadura",
    "Bottom": "Bas",
    "Browse files": "",
    "Browse for an image": "Cercar un imatge",
    "Browse links": "",
    "Bullet list": "Piuses",
    "Cancel": "Anullar",
    "Caption": "T\xedtol",
    "Cell": "Cellula",
    "Cell padding": "Espa\xe7ament int\xe8rne cellula",
    "Cell properties": "Proprietats de la cellula",
    "Cell spacing": "Espa\xe7ament intercellullas",
    "Cell styles": "",
    "Cell type": "Tipe de cellula",
    "Center": "Centre",
    "Characters": "Caract\xe8rs",
    "Characters (no spaces)": "Caract\xe8rs (sens espaci)",
    "Circle": "Cercle",
    "Class": "Clase",
    "Clear formatting": "Escafar la mesa en forma",
    "Close": "Tampar",
    "Code": "C\xf2de",
    "Code sample...": "Exemple de c\xf2di...",
    "Code view": "",
    "Color Picker": "Trapador de color",
    "Color swatch": "Cambiament de color",
    "Cols": "Colomnas",
    "Column": "Colomna",
    "Column clipboard actions": "",
    "Column group": "Grop de colomnas",
    "Column header": "",
    "Constrain proportions": "Conservar las proporcions",
    "Copy": "Copiar",
    "Copy column": "",
    "Copy row": "Copiar la linha",
    "Could not find the specified string.": "Impossible de trobar la cadena especificada.",
    "Could not load emojis": "",
    "Count": "Comptador",
    "Currency": "Moneda",
    "Current window": "Fen\xe8stra actuala",
    "Custom color": "Color personalizada",
    "Custom...": "Personalizar...",
    "Cut": "Talhar",
    "Cut column": "",
    "Cut row": "Talhar la linha",
    "Dark Blue": "Blau escur",
    "Dark Gray": "Gris escur",
    "Dark Green": "Verd escur",
    "Dark Orange": "Irange escur",
    "Dark Purple": "Violet escur",
    "Dark Red": "Roge escur",
    "Dark Turquoise": "Turquesa escur",
    "Dark Yellow": "Jaune escur",
    "Dashed": "",
    "Date/time": "Data/ora",
    "Decrease indent": "Demesir l'alin\xe8a",
    "Default": "Per defaut",
    "Delete accordion": "",
    "Delete column": "Suprimir la colomna",
    "Delete row": "Suprimir la linha",
    "Delete table": "Suprimir lo tabl\xe8u",
    "Dimensions": "",
    "Disc": "Disco",
    "Div": "Div",
    "Document": "",
    "Dotted": "",
    "Double": "",
    "Drop an image here": "Depausatz un imatge aqu\xed",
    "Dropped file type is not supported": "",
    "Edit": "Editar",
    "Embed": "Integrat",
    "Emojis": "",
    "Emojis...": "",
    "Error": "",
    "Error: Form submit field collision.": "",
    "Error: No form element found.": "Error\u202f: cap d\u2019element formulari pas trobat.",
    "Extended Latin": "",
    "Failed to initialize plugin: {0}": "",
    "Failed to load plugin url: {0}": "",
    "Failed to load plugin: {0} from url {1}": "",
    "Failed to upload image: {0}": "Frac\xe0s mandad\xeds imatge : {0}",
    "File": "Fichi\xe8r",
    "Find": "Recercar",
    "Find (if searchreplace plugin activated)": "Cercar (se l\u2019extension Searchreplace es activada)",
    "Find and Replace": "",
    "Find and replace...": "Trobar e rempla\xe7ar...",
    "Find in selection": "",
    "Find whole words only": "Cercar mot enti\xe8r sonque",
    "Flags": "Drap\xe8us",
    "Focus to contextual toolbar": "",
    "Focus to element path": "",
    "Focus to menubar": "Se centrar en la barra del menu",
    "Focus to toolbar": "Se centrar en la barra d'esturments",
    "Font": "Polissa",
    "Font size {0}": "",
    "Font sizes": "Tamans de fu\xf2c",
    "Font {0}": "",
    "Fonts": "Polissas",
    "Food and Drink": "Beure e manjar",
    "Footer": "P\xe8 de pagina",
    "Format": "",
    "Format {0}": "",
    "Formats": "Formats",
    "Fullscreen": "Ecran complet",
    "G": "V",
    "General": "",
    "Gray": "Gris",
    "Green": "Verd",
    "Green component": "",
    "Groove": "",
    "Handy Shortcuts": "Acorchis utils",
    "Header": "Ent\xe8sta",
    "Header cell": "Cellula d'ent\xe8sta",
    "Heading 1": "T\xedtol 1",
    "Heading 2": "T\xedtol 2",
    "Heading 3": "T\xedtol 3",
    "Heading 4": "T\xedtol 4",
    "Heading 5": "T\xedtol 5",
    "Heading 6": "T\xedtol 6",
    "Headings": "T\xedtols",
    "Height": "Nautor",
    "Help": "Ajuda",
    "Hex color code": "",
    "Hidden": "",
    "Horizontal align": "",
    "Horizontal line": "Linha orizontala",
    "Horizontal space": "Espa\xe7ament orizontal",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "ID auri\xe1 de comen\xe7ar per una letra, seguit sonque per de letras, de nombres, de barras, de ponchs, dos ponchs o de barras bassas.",
    "Image is decorative": "",
    "Image list": "Lista d\u2019imatges",
    "Image title": "T\xedtol imatge",
    "Image...": "Imatge...",
    "ImageProxy HTTP error: Could not find Image Proxy": "",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "",
    "ImageProxy HTTP error: Rejected request": "",
    "ImageProxy HTTP error: Unknown ImageProxy error": "",
    "Increase indent": "Aumentar l'alin\xe8a",
    "Inline": "En linha",
    "Insert": "Inserir",
    "Insert Template": "",
    "Insert accordion": "",
    "Insert column after": "Inserir una colomna apr\xe8p",
    "Insert column before": "Inserir una colomna abans",
    "Insert date/time": "Inserir data/ora",
    "Insert image": "Inserir un imatge",
    "Insert link (if link plugin activated)": "Inserir un ligam (se l\u2019extension Ligam es activada)",
    "Insert row after": "Inserir una linha apr\xe8p",
    "Insert row before": "Inserir una linha abans",
    "Insert table": "Inserir un tabl\xe8u",
    "Insert template...": "Inserir un mod\xe8l...",
    "Insert video": "Inserir una vid\xe8o",
    "Insert/Edit code sample": "Inserir/Modificar exemple de c\xf2di",
    "Insert/edit image": "Inserir/modificar un imatge",
    "Insert/edit link": "Inserir/modificar un ligam",
    "Insert/edit media": "Inserir/modificar un m\xe8dia",
    "Insert/edit video": "Inserir/modificar una vid\xe8o",
    "Inset": "",
    "Invalid hex color code: {0}": "",
    "Invalid input": "",
    "Italic": "Italica",
    "Justify": "Justificar",
    "Keyboard Navigation": "Acorchis clavi\xe8r",
    "Language": "Lenga",
    "Learn more...": "Ne saber mai...",
    "Left": "Esqu\xe8rra",
    "Left to right": "D'esqu\xe8rra cap a drecha",
    "Light Blue": "Blau clar",
    "Light Gray": "Gris clar",
    "Light Green": "Verd clar",
    "Light Purple": "Violet clar",
    "Light Red": "Roge clar",
    "Light Yellow": "Jaune clar",
    "Line height": "",
    "Link list": "Lista de ligams",
    "Link...": "Ligam...",
    "List Properties": "",
    "List properties...": "",
    "Loading emojis...": "",
    "Loading...": "",
    "Lower Alpha": "Alfa minuscula",
    "Lower Greek": "Gr\xe8c minuscula",
    "Lower Roman": "Roman minuscula",
    "Match case": "Respectar la cassa",
    "Mathematical": "",
    "Media poster (Image URL)": "",
    "Media...": "M\xe8dia...",
    "Medium Blue": "Blau mejan",
    "Medium Gray": "Gris mejan",
    "Medium Purple": "Violet mejan",
    "Merge cells": "Fusionar las cellulas",
    "Middle": "Mitan",
    "Midnight Blue": "Blau nu\xe8ch",
    "More...": "Mai...",
    "Name": "Nom",
    "Navy Blue": "Blau marin",
    "New document": "Document nov\xe8l",
    "New window": "Fen\xe8stra nov\xe8la",
    "Next": "Seg",
    "No": "Non",
    "No alignment": "Pas d'alinhament",
    "No color": "Pas de color",
    "Nonbreaking space": "Espaci insecable",
    "None": "Pas cap",
    "Numbered list": "Lista numerotada",
    "OR": "O",
    "Objects": "Obj\xe8ctes",
    "Ok": "D'ac\xf2rdi",
    "Open help dialog": "",
    "Open link": "",
    "Open link in...": "Dobrir lo ligam dins...",
    "Open popup menu for split buttons": "",
    "Orange": "Irange",
    "Outset": "",
    "Page break": "Pagina copada",
    "Paragraph": "Paragraf",
    "Paste": "Pegar",
    "Paste as text": "Pegar coma de t\xe8xte",
    "Paste column after": "",
    "Paste column before": "",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": 'Lo quichapapi\xe8rs es ara en m\xf2de "t\xe8xte plen". Los contenguts ser\xe0n pegats sens ret\xe9ner los formatatges fins al moment que desactivaretz aquesta opcion.',
    "Paste or type a link": "Pegatz o picatz un ligam",
    "Paste row after": "Pegar la linha apr\xe8p",
    "Paste row before": "Pegar la linha abans",
    "Paste your embed code below:": "Pegatz v\xf2tre c\xf2di d'integracion \xe7aij\xf3s :",
    "People": "Gents",
    "Plugins": "Extensions",
    "Plugins installed ({0}):": "Extensions installadas ({0})\u202f:",
    "Powered by {0}": "Propulsat per {0}",
    "Pre": "Pre",
    "Preferences": "Prefer\xe9ncias",
    "Preformatted": "Preformatat",
    "Premium plugins:": "Extensions Premium\u202f:",
    "Press the Up and Down arrow keys to resize the editor.": "",
    "Press the arrow keys to resize the editor.": "",
    "Press {0} for help": "",
    "Preview": "Previsualizar",
    "Previous": "Precedent",
    "Print": "",
    "Print...": "Imprimir...",
    "Purple": "Violet",
    "Quotations": "Citacions",
    "R": "",
    "Range 0 to 255": "",
    "Red": "Roge",
    "Red component": "",
    "Redo": "Refar",
    "Remove": "Eliminar",
    "Remove color": "Tirar la color",
    "Remove link": "Suprimir lo ligam",
    "Replace": "Rempla\xe7ar",
    "Replace all": "Rempla\xe7ar tot",
    "Replace with": "Rempla\xe7ar per",
    "Resize": "Redimensionar",
    "Restore last draft": "Restablir lo darri\xe8r borrolhon",
    "Reveal or hide additional toolbar items": "",
    "Rich Text Area": "",
    "Rich Text Area. Press ALT-0 for help.": "",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Z\xf2na T\xe8xte Ric. Quichar sus ALT-F9 pel men\xfa. Quichar sus ALT-F10 per la barra d'aisinas. Quichar sus ALT-0 per d'ajuda.",
    "Ridge": "",
    "Right": "Drecha",
    "Right to left": "De drecha cap a esqu\xe8rra",
    "Row": "Linha",
    "Row clipboard actions": "",
    "Row group": "Grop de linhas",
    "Row header": "",
    "Row properties": "Proprietats de la linha",
    "Row type": "Tipe de linha",
    "Rows": "Linhas",
    "Save": "Enregistrar",
    "Save (if save plugin activated)": "Enregistrar (se l\u2019exension Enregistrar es activada)",
    "Scope": "Espandida",
    "Search": "Cercar",
    "Select all": "Seleccionar tot",
    "Select...": "Seleccionar...",
    "Selection": "Seleccion",
    "Shortcut": "Acorchi",
    "Show blocks": "Afichar los bl\xf2ts",
    "Show caption": "Mostrar legenda",
    "Show invisible characters": "Far veire los caract\xe8rs invisibles",
    "Size": "Talha",
    "Solid": "",
    "Source": "Font",
    "Source code": "C\xf2de font",
    "Special Character": "Caract\xe8r especial",
    "Special character...": "Caract\xe8r especial...",
    "Split cell": "Devesir la cellula",
    "Square": "Carrat",
    "Start list at number": "",
    "Strikethrough": "Ralhat",
    "Style": "Estil",
    "Subscript": "Indici",
    "Superscript": "Exponent",
    "Switch to or from fullscreen mode": "",
    "Symbols": "Simb\xf2ls",
    "System Font": "Polissa sist\xe8ma",
    "Table": "Tabl\xe8u",
    "Table caption": "",
    "Table properties": "Proprietats del tabl\xe8u",
    "Table styles": "",
    "Template": "Mod\xe8l",
    "Templates": "Mod\xe8ls",
    "Text": "T\xe8xte",
    "Text color": "Color del t\xe8xte",
    "Text color {0}": "",
    "Text to display": "T\xe8xte d'afichar",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "Sembla que l'URL qu'av\xe8tz entrada es una adre\xe7a e-mail. Vol\xe8tz apondre lo prefix mailto: necessari ?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "Sembla que l'URL qu'av\xe8tz entrada es un ligam ext\xe8rne. Vol\xe8tz apondre lo prefix http:// necessari ?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "",
    "Title": "T\xedtol",
    "To open the popup, press Shift+Enter": "Per dobrir dins una fen\xe8stra sorgissenta, quichatz Maj+Entrada",
    "Toggle accordion": "",
    "Tools": "Aisinas",
    "Top": "Naut",
    "Travel and Places": "Viatge e L\xf2cs",
    "Turquoise": "Turquesa",
    "Underline": "Solinhat",
    "Undo": "Desfar",
    "Upload": "Enviar",
    "Uploading image": "Pujant imatge",
    "Upper Alpha": "Alfa majuscula",
    "Upper Roman": "Roman majuscula",
    "Url": "",
    "User Defined": "",
    "Valid": "",
    "Version": "",
    "Vertical align": "",
    "Vertical space": "Espa\xe7ament vertical",
    "View": "Veire",
    "Visual aids": "Ajudas visualas",
    "Warn": "Av\xeds",
    "White": "Blanc",
    "Width": "Largor",
    "Word count": "Comptador mot",
    "Words": "Mots",
    "Words: {0}": "Mots : {0}",
    "Yellow": "Jaune",
    "Yes": "\xd2c",
    "You are using {0}": "Utilizatz {0}",
    "You have unsaved changes are you sure you want to navigate away?": "Av\xe8tz de modificacions pas enregistradas, s\xe8tz segur que vol\xe8tz quitar la pagina ?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "V\xf2stre navigador sup\xf2rta pas la c\xf2pia dir\xe8cta. Merc\xe9 d'utilizar las t\xf2cas Ctrl+X/C/V.",
    "alignment": "alinhament",
    "austral sign": "signe austral",
    "cedi sign": "signe cedi",
    "colon sign": "signe colon",
    "cruzeiro sign": "signe cruzeiro",
    "currency sign": "Signe devisa",
    "dollar sign": "signe d\xf2lar",
    "dong sign": "signe dong",
    "drachma sign": "signe drachma",
    "euro-currency sign": "signe devisa europenca ",
    "example": "exemple",
    "formatting": "",
    "french franc sign": "signe franc",
    "german penny symbol": "signe devisa germana",
    "guarani sign": "signe guarani",
    "history": "istoric",
    "hryvnia sign": "signe hryvnia",
    "indentation": "indentacion",
    "indian rupee sign": "signe roble india",
    "kip sign": "signe kip",
    "lira sign": "signe lira",
    "livre tournois sign": "signe livre tournois",
    "manat sign": "signe manat",
    "mill sign": "signe mill",
    "naira sign": "signe naira",
    "new sheqel sign": "signe sheqel",
    "nordic mark sign": "signe marc nordic",
    "peseta sign": "signe peseta",
    "peso sign": "signe peso",
    "ruble sign": "signe roble",
    "rupee sign": "signe roble",
    "spesmilo sign": "signe spesmilo",
    "styles": "estils",
    "tenge sign": "signe tenge",
    "tugrik sign": "signe tugrik",
    "turkish lira sign": "signe lira de Turquia",
    "won sign": "signe won",
    "yen character": "signe yen",
    "yen/yuan character variant one": "",
    "yuan character": "signe yuan",
    "yuan character, in hong kong and taiwan": "",
    "{0} characters": "{0} caract\xe8rs",
    "{0} columns, {1} rows": "",
    "{0} words": "{0} mots"
});